import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Customer } from '@models/customer';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomersService } from '@services/entity/customers.service';
import { RouteDataService } from '@services/route-data/route-data.service';
import { TableFunctionsService } from '@services/table/table-functions.service';
import { plainToClass } from 'class-transformer';
import '@angular/localize/init';
import { ComponentBase } from '@abstracts/component-base';
import { OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { User } from 'oidc-client';
import { UsersService } from '../../../../services/entity/users.service';
import { UserDto } from '../../../../dto/userDto';
import { BlackboxService } from '@services/entity/blackbox.service';
import { ChargingStationsService } from '../../../../services/entity/charging-stations.service';

@Component({
  selector: 'app-customer-overview',
  templateUrl: './customer-overview.component.html',
  styleUrls: ['./customer-overview.component.scss']
})
export class CustomerOverviewComponent extends ComponentBase implements OnInit, OnDestroy {

  public className = 'CustomerOverviewComponent';

  public primaryKey;
  public masterUserByCustomer: UserDto;
  public hasBlackbox: boolean = false;

  public activeTab = 'users';
  public title = '';

  public routerSubscription: Subscription;

  public isProduction: boolean = false;
  public isSupporter: boolean = false;

  public links = [
    { title: $localize`:@@CustomerOverviewDashboardTitle:Dashboard`, route: 'dashboard' },
    { title: $localize`:@@CustomerOverviewUsersTitle:Benutzer`, route: 'users' },
    { title: $localize`:@@CustomerOverviewRfidTitle:RFID-Karten`, route: 'rfid' },
    { title: $localize`:@@CustomerOverviewUnassignedRfidTitle:Nicht zugeteilte RFID-Karten`, route: 'unassigned-rfid' },
    { title: $localize`:@@CustomerOverviewPricingsTitle:Tarife`, route: 'pricings' },
    { title: $localize`:@@CustomerOverviewInvoiesTitle:Rechnungen`, route: 'invoices' },
    { title: $localize`:@@CustomerOverviewChargingstationsTitle:Ladestationen`, route: 'chargingstations' },
    { title: $localize`:@@CustomerOverviewChargingStatisticsTitle:Ladestatistik`, route: `charging-statistics` },
    { title: $localize`:@@CustomerOverviewDeliveryNotesTitle: Lieferscheine`, route: `delivery-notes` },
    { title: $localize`:@@CustomerOverviewStatusLogTitle:Status-Log`, route: 'chargingstations-status-log' },
    { title: $localize`:@@CustomerOverviewTransactionsTitle:Ladevorgänge`, route: 'transactions' },
    { title: $localize`:@@CustomerOverviewPaymentReceiptTitle:Zahlungsbelege`, route: 'payment-receipts' },
    { title: $localize`:@@CustomerOverviewGroupsTitle:Gruppen`, route: 'groups' },
    { title: $localize`:@@CustomerOverviewProfileTitle:Konto`, route: 'profile' },
    { title: $localize`:@@CustomerOverviewPermissionsTitle:Abo-Modell`, route: 'permissions' },
    { title: $localize`:@@CustomerOverviewHistoryTitle:Notizen`, route: 'history' },
    { title: $localize`:@@CustomerOverviewEnergy-MonitorTitle:Energiemonitor`, route: 'energy-monitor' },
    { title: $localize`:@@CustomerOverviewBidiTitle:Bidi-Laden`, route: 'bidi-charging' }
  ];
    public hasBidi: boolean;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public tableFunctions: TableFunctionsService,
    private routeDataService: RouteDataService,
    public chargingStationsService: ChargingStationsService,
    private usersService: UsersService,
    public blackboxService: BlackboxService,
    injector: Injector) {
      super(injector);
  }




  ngOnInit(): void {
    super.ngOnInit();

    this.routeDataService.params = this.activatedRoute.snapshot.params;
    this.primaryKey = this.activatedRoute.snapshot.params.key;
    this.isProduction = this.activatedRoute.snapshot.data['isProduction'];
    this.isSupporter = this.authenticationService.userHasRole('Supporter')

    if (this.isProduction) {
      this.links = [];
      this.links = [
        { title: $localize`:@@CustomerOverviewChargingstationsTitle:Ladestationen`, route: 'chargingstations' },
        { title: $localize`:@@CustomerOverviewStatusLogTitle:Status-Log`, route: 'chargingstations-status-log' },
        { title: $localize`:@@CustomerOverviewTransactionsTitle:Ladevorgänge`, route: 'transactions' },
      ];
    }

    this.initializeEntity();

    this.determineActiveTab();

    this.eventService.entityRefresh$.subscribe(result => {
      this.initializeEntity();
    });

    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.determineActiveTab();
      }
    });
    this.checkForBlackBox();
    this.checkForBidi();
  }

  checkForBlackBox() {
    this.blackboxService.getByCustomerId(this.primaryKey).subscribe(res => {
      if (res.length >= 1) {
        this.hasBlackbox = true;
      } else {
        this.hasBlackbox = false;
      }
    }, error => { });
  }

  checkForBidi() {
    this.chargingStationsService
      .checkChargingStationsOfCustomerHasBidi(this.primaryKey)
      .subscribe(res => {
        if (res) {
          this.hasBidi = true;
        } else {
          this.hasBidi = false;
        }
      });
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  initializeEntity() {
   this.usersService.getMasterUserByCustomerId(this.primaryKey).subscribe(result => {
      this.masterUserByCustomer = plainToClass(UserDto, result);
    }, error => { });
  }

  determineActiveTab() {
    var currentRoute = this.activatedRoute.children[0]?.snapshot.url[0]?.path;
    for (let link of this.links) {
      if (currentRoute == link.route) {
        this.activeTab = link.route;
        this.title = link.title;
      }
    }
  }
}
